import swal from 'sweetalert'
import { merge } from 'lodash'

export default {
  async alert (options = {}) {
    const result = await swal(options)

    return result
  },

  confirm (options = {}) {
    return this.alert(merge({
      title: 'Are you sure?',
      icon: false,
      buttons: {
        cancel: {
          text: 'Cancel',
          value: false,
          visible: true,
          className: 'btn btn-light btn-rounded',
          closeModal: true
        },
        confirm: {
          text: 'Yes',
          value: true,
          visible: true,
          className: 'btn btn-secondary btn-rounded',
          closeModal: true
        }
      },
      dangerMode: true,
      closeOnClickOutside: false
    }, options))
  },

  warning (options = {}) {
    return this.alert(merge({
      title: 'Warning!',
      text: 'Something went wrong',
      icon: 'warning',
      button: 'Close',
      dangerMode: true,
      closeOnClickOutside: false
    }, options))
  },

  info (options = {}) {
    return this.alert(merge({
      icon: 'info',
      button: 'Close',
      dangerMode: false,
      closeOnClickOutside: false
    }, options))
  }
}
